import { ISalesRegister } from '../../sales-registers/models/sales-register.model';
import { IBasicUserDetails } from '../../users/models/basic-user-details.model';
import { ISaleLineItem } from './sale-line-item.model';
import { ISalePayment } from './sale-payment.model';
import { ISaleTax } from './sale-tax.model';

export enum SaleStatus {
  unsaved = 0,
  saved = 1,
  closed = 2,
  voided = 3,
  parked = 4,
  discarded = 5,
  paid = 6
}

export interface ISale {
  id: number;
  businessId?: number;
  businessName?: string;
  saleDateUtc?: Date;
  updatedAtUtc: Date;
  customer?: IBasicUserDetails;
  customerId?: number;
  registerId: string;
  amountPaid: number;
  changeGiven: number;
  isClosedOrPaid: boolean;
  lineItems: ISaleLineItem[];
  payments: ISalePayment[];
  note: string;
  noteInternal: string;
  reference: string;
  register: ISalesRegister;
  remainingToPay: number;
  salesPerson?: IBasicUserDetails;
  status: SaleStatus;
  taxes: ISaleTax[];
  totalLoyalty: number;
  totalPriceInclTax: number;
  totalTax: number;
}
